Backbone.Radio.channel('utilities').reply('image-parse',function(o){
	//console.log('image-parse',o)
    _.defaults(o, {
	     json:null
	    ,desiredProfile:"show-mezzanine16x9"
    });
    
    
    /************************************
        Program Image
        - They come as a json string, so parse that.
        We don't know what types of images we have, so loop to look.
     ************************************/   
    var img = null;
    var has_showcase = null;
    var has_colorlogo = null;
    var imgs = JSON.parse(o.json);
    if(imgs && imgs.length){
        img = _.find(imgs,function(i){
            //track these just for backup in case we can't find 'show-mezzanine16x9'
            //if(i.profile == "show-showcase"){   has_showcase  = this; }
            //if(i.profile == "show-color-logo"){ has_colorlogo = this; }
            
            //return i.profile == "show-mezzanine16x9";
            return i.profile == o.desiredProfile;
        })
        //if(!img){ //no 16x9, so try something else
            //note these are in reverse order of preference
        //    if(has_colorlogo) img = has_colorlogo;
        //    if(has_showcase) img = has_showcase;
        //}
        //if(!img){ //still nothing, grab the first one
        //    img = imgs[0];
        //}
        if(img){
	        img = img.image;
	    }
    }
    
    
    return img;
});

